import Button from '@material-tailwind/react/Button';
import Image from '@material-tailwind/react/Image';
import H3 from '@material-tailwind/react/Heading3';
import Icon from '@material-tailwind/react/Icon';
import LeadText from '@material-tailwind/react/LeadText';
import debFile from 'assets/files/dream-joystick-bridge_1.0.0_amd64.deb';
import pkgFile from 'assets/files/dream-joystick-bridge_1.0.0_arm.pkg';
import exeFile from 'assets/files/dream-joystick-bridge_1.0.0_arm.exe';

export default function DreamJoystickContent(props) {
    return (
        <section className="relative py-16 bg-gray-100">
            <div className="container max-w-7xl px-4 mx-auto">
                <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-2xl -mt-64">
                    <div className="px-6">
                        <div className="flex flex-wrap justify-center">
                            <div className="w-full lg:w-3/12 px-4 lg:order-2 flex justify-center">
                                <div className="relative">
                                    <div className="w-40 -mt-20">
                                        <Image
                                            src={props.icon}
                                            alt="Profile picture"
                                            raised
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="w-full lg:w-4/12 px-4 lg:order-3 lg:self-center flex justify-center mt-10 lg:justify-end lg:mt-0">
                                <Button color="lightBlue" ripple="light">
                                    Google Play
                                </Button>
                            </div>
                            <div className="w-full lg:w-4/12 px-4 lg:order-1">
                                <div className="flex justify-center py-4 lg:pt-4 pt-8">
                                    <div className="mr-4 p-3 text-center">
                                        <span className="text-xl font-bold block uppercase tracking-wide text-gray-900">
                                            Free
                                        </span>
                                        <span className="text-sm text-gray-700">
                                            Price
                                        </span>
                                    </div>
                                    <div className="mr-4 p-3 text-center">
                                        <span className="text-xl font-bold block uppercase tracking-wide text-gray-900">
                                            0
                                        </span>
                                        <span className="text-sm text-gray-700">
                                            Ads
                                        </span>
                                    </div>
                                    <div className="lg:mr-4 p-3 text-center">
                                        <span className="text-xl font-bold block uppercase tracking-wide text-gray-900">
                                            3
                                        </span>
                                        <span className="text-sm text-gray-700">
                                            Themes
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="text-center my-8">
                            <H3 color="gray">{props.title}</H3>
                            <div className="mt-0 mb-2 text-gray-700 font-medium flex items-center justify-center gap-2">
                                <Icon name="place" size="xl" />
                                West Java, Indonesia
                            </div>
                            <div className="mb-2 text-gray-700 mt-10 flex items-center justify-center gap-2">
                                <Icon name="shop" size="xl" />
                                Google Play
                            </div>
                        </div>

                        <div className="mb-10 py-2 border-t border-gray-200 text-center">
                            <div className="flex flex-wrap justify-center">
                                <div className="w-full lg:w-9/12 px-4 flex flex-col items-center">
                                    <LeadText color="blueGray">
                                        Turn your Android phone into a full-featured wireless gamepad — no extra hardware needed.
                                    </LeadText>

                                    <div className="w-full text-left mt-4 text-gray-700">
                                        <p className="mb-4">
                                            Dream Joystick connects to your PC over Wi-Fi and lets you play your favorite games with a real controller layout right on your screen. Open the app, enter your PC's IP address and port, tap Connect, and you're live.
                                        </p>

                                        <p className="font-semibold text-gray-900 mb-2">FULL CONTROLLER LAYOUT</p>
                                        <ul className="list-disc list-inside mb-4 space-y-1">
                                            <li>Analog Stick + D-Pad (switchable with one tap)</li>
                                            <li>Face buttons — ✕ ○ □ △</li>
                                            <li>Shoulder buttons — L1, L2, R1, R2</li>
                                            <li>Menu buttons — SELECT, START, PS</li>
                                            <li>Touchpad area</li>
                                        </ul>

                                        <p className="font-semibold text-gray-900 mb-2">WIRELESS VIA WI-FI</p>
                                        <p className="mb-4">
                                            Dream Joystick sends your inputs to your PC over UDP on your local network. A real-time status indicator and packet counter let you know the connection is working.
                                        </p>

                                        <p className="font-semibold text-gray-900 mb-2">3 VISUAL THEMES</p>
                                        <ul className="list-disc list-inside mb-4 space-y-1">
                                            <li><span className="font-medium">Classic PS</span> — Deep navy with electric blue accents, inspired by classic PlayStation hardware</li>
                                            <li><span className="font-medium">Dark Glass</span> — Minimal frosted glass aesthetic with translucent panels</li>
                                            <li><span className="font-medium">Neon Cyber</span> — Deep purple background with glowing neon highlights</li>
                                        </ul>

                                        <p className="font-semibold text-gray-900 mb-2">NO ADS. NO SIGN-IN.</p>
                                        <p>Open the app, connect, and play. Nothing else required.</p>
                                    </div>

                                    <div className="w-full mt-8 pt-6 border-t border-gray-200">
                                        <p className="font-semibold text-gray-900 mb-1 text-center">DOWNLOAD BRIDGE SERVER</p>
                                        <p className="text-sm text-gray-500 mb-4 text-center">
                                            Install the bridge on your PC to receive gamepad inputs over Wi-Fi.
                                        </p>
                                        <div className="flex flex-wrap justify-center gap-4">
                                            <a
                                                href={debFile}
                                                download="dream-joystick-bridge_1.0.0_amd64.deb"
                                            >
                                                <Button color="blueGray" ripple="light">
                                                    <i className="fab fa-linux mr-2" />
                                                    Linux (.deb)
                                                </Button>
                                            </a>
                                            <a
                                                href={pkgFile}
                                                download="dream-joystick-bridge_1.0.0_arm.pkg"
                                            >
                                                <Button color="blueGray" ripple="light">
                                                    <i className="fab fa-apple mr-2" />
                                                    macOS (.pkg)
                                                </Button>
                                            </a>
                                            <a
                                                href={exeFile}
                                                download="dream-joystick-bridge_1.0.0_arm.exe"
                                            >
                                                <Button color="blueGray" ripple="light">
                                                    <i className="fab fa-windows mr-2" />
                                                    Windows (.exe)
                                                </Button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
